import React from "react";
import "./SocialCanvassing.css";
import "bootstrap/dist/css/bootstrap.min.css";
import OptionsCards from "../../components/OptionsCards/OptionsCards";
import PromoBanner from "../../components/PromoBanner/PromoBanner";

export default function SocialCanvassing({
  selectedSocialCanvassOption,
  onSocialCanvassCheckboxChange,
}) {
  const options = [
    {
      id: 5,
      title: "Social Canvass",
      description:
        "We search, identify and secure a person's public social media profile on multiple social media platforms to locate actionable data.",
      features: [
        { title: "Search multiple social media platforms", isDisabled: false },
        { title: "Locate actionable data", isDisabled: false },
      ],
      header: "",
      locations: [],
    },
    {
      id: 7,
      title: "I Do NOT Want a Social Canvass Completed",
      description: "",
      features: [],
      header: "",
      locations: [],
    },
  ];
  return (
    <div>
      <h1 className="txt-orange" id="SocialCanvassing">Social Canvassing</h1>
      <div className="container">
        <PromoBanner />
        <OptionsCards
          options={options}
          selectedOption={selectedSocialCanvassOption}
          onCheckboxChange={(option) => onSocialCanvassCheckboxChange(option)}
        />
      </div>
    </div>
  );
}
